// SA-8637: Sentry loaded from CDN (see src/index.html + src/types/sentry-cdn.d.ts).
import * as React from 'react';
import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export class SentryErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // SA-8637: defensive guard — see sentry.utils.ts.
    if (typeof Sentry === 'undefined') {
      return;
    }
    Sentry.captureException(error, {
      tags: {
        source: 'react-error-boundary'
      },
      extra: {
        componentStack: errorInfo.componentStack
      }
    });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div style={{ padding: 24, textAlign: 'center', color: '#666' }}>
          <p>Something went wrong. Please refresh the page and try again.</p>
        </div>
      );
    }

    return this.props.children;
  }
}
